import React from 'react';
import { connect } from 'react-redux';

const { bindActionCreators } = require('redux');
import { Modal } from 'react-bootstrap';
import IconClose from '../../../assets/icons/icon-close.svg';

import { formatText } from 'core/i18n';
import { recordPage, recordEvent,recordEventCustomOnly } from 'utilities/uTagging';

const initialActions = require('actions/initialActions');
import OKPDFViewer from '../../../components/commons/OKPdfViewer/OKPdfViewer';
import { base64ToBlob, downloadAsFile } from '../../../utilities/APIRequestHelper';
import { printPdf } from '../../../utilities/pdf';

class VedacomModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            readedDocument: false,
            height: 0,
        };
        this.pdfBoxRef = this.pdfBoxRef.bind(this);
    }

    componentDidMount() {
        const {
            initialActions: { getPdfMerge },
        } = this.props;
        getPdfMerge(['https://www.openbank.es/assets/static/pdf/Productos/Otros/Consulta_Tesoreria.pdf']);
    }

    componentDidUpdate(prevProps, prevState) {
        const { showModal } = this.props;
        const { showModal: prevShowModal } = prevProps;
        const { readedDocument } = this.state;
        const { readedDocument: prevReadedDocument } = prevState;
        if (!prevShowModal && showModal) {
            recordPage(
                '/onboarding/autorizacion-consulta-datos-tgss/',
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                'ares',
                {
                    tipoPagina: 'generica',
                    tipoProceso: 'onboarding',
                    pasoProceso: 'autorizacion-consulta-datos-tgss',
                    tipoOnboarding: 'ares',
                    productoOnboardingDetalle: 'prestamo ares',
                }
            );
        }
        if (!prevReadedDocument && readedDocument) {
            recordEvent(
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                {
                    accionEvento: 'documento leido',
                    etiquetaEvento:formatText('vedacon-docname_ares'),
                    categoriaEvento: 'interaccion en autorizacion de consulta tgss',
                }
            );
        }
    }

    pdfBoxRef(ref) {
        if (ref) {
            const boxHeight = ref.getBoundingClientRect().height;
            this.setState({ height: boxHeight - 100 });
        }
    }

    getFormattedPdfFile = () => {
        const { pdfFile } = this.props;
        return `data:application/pdf;base64,${pdfFile}`;
    };

    handleOnDownload = () => {
        const pdfFile = this.getFormattedPdfFile();
        downloadAsFile(base64ToBlob(pdfFile), 'application/pdf', `${formatText('ms_onb-dowloadDocument_ares')}.pdf`);
    };

    handleOnPrint = () => {
        const pdfFile = this.getFormattedPdfFile();
        printPdf(pdfFile);
    };

    tagScrollButton = () => {
        recordEventCustomOnly({
            accionEvento: 'ir al final',
            categoriaEvento: 'interaccion en autorizacion de consulta tgss',
        });    };

    render() {
        const { showModal, handleClose, confirmAcceptance, isAccepted, pdfFile } = this.props;
        return (
            <Modal
                bsSize="lg"
                show={showModal}
                onExit={() => {
                    !isAccepted &&
                        this.setState({
                            readedDocument: false,
                        });
                }}
                dialogClassName={'vedacom__modal__container'}
            >
                <div className="vedacom__modal-heading">
                    <div className="vedacom__modal-heading__close-icon">
                        <img
                            src={IconClose}
                            onClick={() => {
                                handleClose();
                                recordEvent(
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    {
                                        accionEvento: 'salir',
                                        categoriaEvento: 'interaccion en autorización de consulta tgss',
                                    }
                                );
                            }}
                        />
                    </div>
                    <h4>{formatText('vedacon-docname_ares')}</h4>
                </div>
                <div ref={this.pdfBoxRef} className="vedacom__modal-pdf-viewer">
                    <OKPDFViewer
                        showLogo={true}
                        showPagination={false}
                        showScroll={true}
                        displayScrollButton={true}
                        scrollButtonAction={this.tagScrollButton}
                        viewScalableHeight={showModal ? this.state.height : 1}
                        onDownload={this.handleOnDownload}
                        onPrint={this.handleOnPrint}
                        title={formatText('vedacon-text4_ares')}
                        errorComponent={() => ({})}
                        pdfFile={this.getFormattedPdfFile()}
                        handleDocumentReaded={() => {
                            this.setState({ readedDocument: true });
                        }}
                    />
                </div>

                <div className="vedacom__modal-buttons">
                    <div>
                        {!isAccepted && (
                            <button
                                className="form__button form__button-transparent"
                                onClick={() => {
                                    handleClose();
                                    recordEvent(
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        undefined,
                                        {
                                            accionEvento: 'cancelar',
                                            categoriaEvento: 'interaccion en autorizacion de consulta tgss',
                                        }
                                    );
                                }}
                                aria-label="close-btn"
                            >
                                {!isAccepted && formatText('button-cancel')}
                            </button>
                        )}
                    </div>
                    {!isAccepted && this.state.readedDocument && (
                        <button
                            className="form__button form__button-secondary"
                            onClick={e => {
                                confirmAcceptance(e);
                                recordEvent(
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    {
                                        accionEvento: 'confirmar',
                                        categoriaEvento: 'interaccion en autorización de consulta tgss',
                                    }
                                );
                            }}
                            disabled={!this.state.readedDocument}
                            aria-label="confirm-btn"
                        >
                            {formatText('button-confirm')}
                        </button>
                    )}
                    {isAccepted && (
                        <button
                            className="form__button form__button-secondary"
                            onClick={e => {
                                confirmAcceptance(e);
                            }}
                            aria-label="confirm-btn"
                        >
                            {formatText('button-understood')}
                        </button>
                    )}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    pdfFile: state.initialStep.get('pdfDownloadLink'),
});

const mapDispatchToProps = dispatch => ({
    initialActions: bindActionCreators(initialActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VedacomModal);
